var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 357.576 357.576",
    style: {
      enableBackground: "new 0 0 357.576 357.576"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    d: "M300.807,88.652l-94.235-77.447C198.809,4.817,185.218,0,174.958,0h-108.5C53.223,0,42.456,10.602,42.456,23.636 c0.002,3.121,0.168,312.155,0.168,313.775c0,11.805,8.258,20.05,20.082,20.05c7.5,0,229.139,0.115,229.139,0.115 c12.835,0,23.276-10.726,23.276-23.909V119.673C315.121,108.7,308.967,95.364,300.807,88.652z M66.444,1c0.005,0,0.009,0,0.014,0h0 C66.454,1,66.449,1,66.444,1z M239.589,235.915l-54.232,77.407c-1.551,2.213-3.88,3.482-6.391,3.482c-2.51,0-4.839-1.27-6.39-3.482 l-54.227-77.402c-1.684-2.402-1.978-5.09-0.787-7.378c1.191-2.289,3.653-3.542,6.587-3.542h31.971v-76.735 c0-4.963,4.078-9.265,9.041-9.265h27.622c4.963,0,9.337,4.302,9.337,9.265V225h31.668c2.933,0,5.395,1.251,6.586,3.539 C241.565,230.827,241.272,233.513,239.589,235.915z M206.009,113c-14.743,0-15.889-12.578-15.889-16.433V30.963L293.601,113H206.009 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDownloadFile);
export default __webpack_public_path__ + "static/media/ico-download-file.12af9651fd1024b401db0d1b8baacf75.svg";
export { ForwardRef as ReactComponent };